import translations from "../locales/onBoarding.json";

export const t = (key, params) => {
  if (!key) return "";
  let text = translations[key] || key;
  if (params && typeof params === "object") {
    Object.entries(params).forEach(([name, value]) => {
      text = String(text).replace(
        new RegExp(`\\{\\{${name}\\}\\}`, "g"),
        value ?? ""
      );
    });
  }
  return text;
};

export const useTranslation = () => ({ t });
